import { Link } from 'react-router-dom';
import { Github, Twitter, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-zinc-800 bg-gray-50 dark:bg-zinc-900">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <h3 className="font-display font-bold text-lg mb-4 text-gray-900 dark:text-zinc-100">Open Card Vault</h3>
            <p className="text-sm text-gray-500 dark:text-zinc-500 mb-3">
              The ultimate marketplace for trading card enthusiasts.
            </p>
            <Link to="/about" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">About Us</Link>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-800 dark:text-zinc-200">Marketplace</h4>
            <ul className="space-y-2">
              <li><Link to="/explore" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Explore Cards</Link></li>
              <li><Link to="/marketplace" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Buy & Sell</Link></li>
              <li><Link to="/listings/new" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Create Listing</Link></li>
              <li><Link to="/forum" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Community Forum</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-800 dark:text-zinc-200">Account</h4>
            <ul className="space-y-2">
              <li><Link to="/dashboard" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Dashboard</Link></li>
              <li><Link to="/collection" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">My Collection</Link></li>
              <li><Link to="/wishlist" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Wishlist</Link></li>
            </ul>
          </div>

          {/* Support & Legal */}
          <div>
            <h4 className="font-semibold mb-4 text-gray-800 dark:text-zinc-200">Support</h4>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Contact Us</Link></li>
              <li><Link to="/guide" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">How It Works</Link></li>
              <li><Link to="/legal/privacy" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/legal/terms" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Terms of Service</Link></li>
              <li><Link to="/legal/community-guidelines" className="text-sm text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">Community Guidelines</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-zinc-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="text-center sm:text-left">
            <p className="text-sm text-gray-400 dark:text-zinc-500">
              © 2026 Open Card Vault. All rights reserved.
            </p>
            <p className="text-xs text-gray-400 dark:text-zinc-600 mt-1">
              Must be 13+ to register. Marketplace features require 18+.
            </p>
          </div>
          <div className="flex space-x-4 mt-4 sm:mt-0">
            <a href="#" className="text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">
              <Twitter className="h-5 w-5" />
            </a>
            <a href="#" className="text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">
              <Github className="h-5 w-5" />
            </a>
            <a href="#" className="text-gray-500 dark:text-zinc-500 hover:text-brand-600 dark:hover:text-brand-400 transition-colors">
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
